const messages = {
  title: "Sklep",
  description: "Witamy w sklepie z nagrodami. Tutaj możesz wymienić swoje punkty Bridgestone Plus <br/> na nagrody z różnych kategorii. Asortyment produktów <br/> jest regularnie aktualizowany. Mamy nadzieję, że przeglądanie strony sprawi Ci przyjemność.",
  sort: {
    asc: "Cena od najniższej",
    desc: "Cena od najwyższej",
  },
  productSearchBox: {
    from: "punkty od",
    to: "punkty do",
  },
  noProducts: "Nie znaleziono produktów",
  quantity: "Ilość",
  search: "Szukaj",
  perPage: "Elementów na stronę",
  timeUnavailable: "Niedostępne",
  product: "Produkt",
  cart: {
    pointsPerUnit: "Punkty/sztuka",
    pointsSum: "Suma punktów",
  },
  action: "Akcja",
  pointsTotal: "Całkowicie",
  cartRemainPoints: "Punkty w koszyku",
  shoppingCart: "Koszyk",
  emptyCart: "Koszyk jest pusty",
  attributes: "Atrybuty",
  selectAddressP: "Wybierz adres dostawy",
  orderDelivery: "Adres dostawy",
  selectedProducts: "Wybrane produkty",
  orderSummary: "Podsumowanie zamówienia",
  contactPerson: "Osoba kontaktowa",
  selectedAddress: "Wybrany adres dostawy",
  order: {
    success: "Dziękujemy! Zamówienie zostało złożone pomyślnie. Za kilka minut otrzymasz potwierdzenie zamówienia w skrzynce odbiorczej.",
    description: "Tutaj znajdziesz przegląd zamówień ze sklepu z nagrodami.",
    info: "Tutaj znajdziesz przegląd zamówień ze sklepu z nagrodami.",
    date: "Data zamówienia",
    number: "Nr zamówienia",
    status: {
      created: "Utworzone",
      confirm_order: "Potwierdź zamówienie",
      ready_for_shipment: "Gotowe do wysyłki",
      rejected: "Odrzucone",
      processed: "Przetworzone",
      shipped: "Wysłane",
      returned: "Zwrócone",
      finished: "Zakończone",
    },
    anyOrder: "Brak zamówień",
    products: "Produkty",
    quantity_short: "szt.",
    itemRemoved: "niedostępne",
  },
  orders: "Zamówienia",
  notEnoughPoints: "Nie masz wystarczającej liczby punktów.",
  statusText: "Status",
  outOfStock: "Obecnie niedostępne w magazynie",
  productUnavailable: "Ten produkt nie jest już dostępny.",
  deletedProductsTitle: "Produkty niedostępne",
  deletedProductsMessage: "Następujące produkty nie są już dostępne. Usuń je z koszyka, aby kontynuować.",
  removeSelected: "Usuń zaznaczone",
  clearCart: "Opróżnij koszyk",
  removeSelectedConfirm: "Usunąć zaznaczone produkty z koszyka?",
  clearCartConfirm: "Usunąć wszystkie produkty z koszyka?",
  incompleteAddress: {
    firstName: "Proszę dodać imię do adresu dostawy",
    lastName: "Proszę dodać nazwisko do adresu dostawy",
    company: "Proszę dodać nazwę firmy do adresu dostawy",
    street: "Proszę dodać ulicę i numer domu do adresu dostawy",
    postalCode: "Proszę dodać kod pocztowy do adresu dostawy",
    city: "Proszę dodać miasto do adresu dostawy",
    country: "Proszę dodać kraj do adresu dostawy",
    phone: "Proszę dodać numer telefonu do adresu dostawy",
  },
  placeOrder: "Zamówienie wiążące",
  toOrderDelivery: "Przejdź do adresu dostawy",
  toOrderSummary: "Przejdź do podsumowania zamówienia",
  productImg: "Zdjęcie produktu",
  selectAddressBtn: "Wybierz adres",
  perPgae: "Elementów na stronę",
  categories: {
    advertising: {
      title: "Materiały reklamowe",
      desc: "Weź udział bezpośrednio na platformie i zdobądź <br/> 40 dodatkowych punktów do klubu nagród.",
    },
    rewards: {
      title: "Ekskluzywne nagrody",
      desc: "Odkryj ofertę bonusową w naszym centrum szkoleniowym lub u siebie na miejscu.",
    },
    tools: {
      title: "Narzędzia warsztatowe",
      desc: "Wykorzystaj punkty na szkolenia podmiotów trzecich <br/> i obniż koszty.",
    },
    trainings: {
      title: "Szkolenia i kursy",
      desc: "Odkryj ofertę bonusową w naszym centrum szkoleniowym lub u siebie na miejscu.",
    },
    salesroom: {
      title: "Sala sprzedaży",
      desc: "Zaaranżuj salę sprzedaży i zapewnij klientom przyjemny pobyt.",
    },
    hunter: {
      title: "Hunter",
      desc: "Wymień punkty na atrakcyjne wyposażenie warsztatowe Hunter.",
    },
  },
  bestSold: "Najczęściej kupowane",
  seasonal: "Sezonowe",
  affordable: "Prawie gotowe",
  forPoints: "za {points} punktów",
  reachedPoints: "Wymagana liczba punktów osiągnięta",
  remainingPoints: "Brakuje {points} punktów",
  favoriteProducts: {
    description: "Tutaj znajdziesz zapisane produkty.",
  },
  categoryPageDescriptionFallback: "Materiały warsztatowe lub inne produkty wysokiej jakości z logo Bridgestone dla Twojej firmy",
  variant: "Wybieralne warianty",
};
export default {
  messages,
};
